import cardIcon from "@/assets/img/icons/card.svg"
import bankIcon from "@/assets/img/icons/bank.svg"
import stripeIcon from "@/assets/img/icons/stripe.svg"
import paypalCardIcon from "@/assets/img/icons/paypal-card.svg"
import paypalIcon from "@/assets/img/icons/paypal.svg"
import epayIcon from "@/assets/img/icons/epay.svg"
import cashIcon from "@/assets/img/icons/cash.svg"
import noPaymentNeededIcon from "@/assets/img/icons/no-payment-needed.svg"

const defaultIconStyle = { width: 17, height: 17, marginRight: 10, flexShrink: 0, objectFit: 'contain' }

const icons = {
    'bank': { src: bankIcon, alt: 'Bank' },
    'paypal-card': { src: paypalCardIcon, alt: 'PayPal Card' },
    'epay': { src: epayIcon, alt: 'ePay' },
    'cash': { src: cashIcon, alt: 'Cash' },
    'paypal': { src: paypalIcon, alt: 'PayPal' },
    'stripe': { src: stripeIcon, alt: 'Stripe' },
    'card': { src: cardIcon, alt: 'Card' },
    'no-payment-needed': { src: noPaymentNeededIcon, alt: 'No Payment Needed' },
}

export function usePaymentMethodIcon(iconStyle = defaultIconStyle) {
    const getMethodIcon = method => {
        const icon = method && icons[method.name]

        if (icon) {
            return <img src={icon.src} style={iconStyle} alt={icon.alt} />
        }

        return <div style={iconStyle}></div>
    }

    return getMethodIcon
}
